(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminPharmacies', {
                parent: 'app',
                url: '/pharmacies',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.pharmacies.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminPharmacies/adminPharmacies.html',
                        controller: 'AdminPharmaciesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pharmacies');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('adminPharmacyView', {
            abstract: true,
            parent: 'app',
            url: '/pharmacies/search?id:pharmacyId',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'],
                pageTitle: 'sigmaCrmApp.pharmacies.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/displays/adminPharmacies/adminPharmacyView.html',
                    controller: 'AdminPharmacyViewController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmacies');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
